import React, { Component } from 'react'
import { Router, Route, browserHistory, IndexRedirect } from 'react-router'
import './App.css'
import Landing from './pages/Landing'
import Login from './pages/Landing/Login'
import Signup from './pages/Landing/Signup'
import ResetPassword from './pages/Landing/ResetPassword'
import Public from './pages/Public'
import Profile from './pages/Landing/Onboarding/Profile'
import Settings from './pages/Landing/Onboarding/Settings'
import MoreSettings from './pages/Landing/Onboarding/MoreSettings'
import OnboardingNCNDA from './pages/Landing/Onboarding/NCNDA'
import Password from './pages/Landing/Onboarding/Password'
import Terms from './pages/Landing/Onboarding/Terms'
import Success from './pages/Landing/Onboarding/Success'
import SignupError from './pages/Landing/Onboarding/SignupError'
import ActivateAccount from './pages/ActivateAccount'
import LoginAdmin from './pages/LoginAdmin'
import Error from './pages/Error'
import Search from './pages/Search'
import SearchByContinent from './pages/Search/SearchByContinent'
import SearchByCountry from './pages/Search/SearchByCountry'
import SearchByCity from './pages/Search/SearchByCity'
import SearchCityDetails from './pages/Search/SearchCityDetails'
import PropertiesList from './pages/Search/PropertiesList'
import MapSearch from './pages/Search/MapSearch'
import PropertyDetails from './pages/Search/PropertyDetails'
import connectToStores from 'alt-utils/lib/connectToStores'
import { requireAuth, requireAdminAuth } from './sources/AuthSources'
import ProfileSettings from './pages/ProfileSettings'
import PersonalInfo from './pages/ProfileSettings/PersonalInfo'
import Preferences from './pages/ProfileSettings/Preferences'
import Security from './pages/ProfileSettings/Security'
import AdminPublic from './pages/AdminPublic'
import AdminProperties from './pages/AdminProperties'
import AdminPropertyDetails from './pages/AdminProperties/AdminPropertyDetails'
import AdminUsers from './pages/AdminUsers'
import AdminUserDetails from './pages/AdminUsers/AdminUserDetails'
import AdminRequests from './pages/AdminRequests'
import AdminCategories from './pages/AdminCategories'
import EditCategory from './pages/AdminCategories/EditCategory'
import AdminLocations from './pages/AdminLocations/'
import AdminCities from './pages/AdminLocations/AdminCities'
import EditCity from './pages/AdminLocations/EditCity'
import AdminContinents from './pages/AdminLocations/AdminContinents'
import EditContinent from './pages/AdminLocations/EditContinent'
import AdminCountries from './pages/AdminLocations/AdminCountries'
import EditCountry from './pages/AdminLocations/EditCountry'
import EditAdmin from './pages/AdminAdmins/EditAdmin'
import AdminsOverview from './pages/AdminAdmins/AdminsOverview'
import Favorite from './pages/Favorite'
import FavoriteList from './pages/Favorite/FavoriteList'
import FavoriteMap from './pages/Favorite/FavoriteMap'
import FavoriteProperties from './pages/Favorite/FavoriteProperties'
import Agreements from './pages/Agreements'
import SalesMandate from './pages/Agreements/SalesMandate'
import AmbassadorAgreement from './pages/Agreements/AmbassadorAgreement'
import CollaborationAgreement from './pages/Agreements/CollaborationAgreement'
import LetterOfIntent from './pages/Agreements/LetterOfIntent'
import NDA from './pages/Agreements/NDA'
import NDFA from './pages/Agreements/NDFA'
import CommissionAgreement from './pages/Agreements/CommissionAgreement'
import AboutPangaea from './pages/Landing/AboutPangaea'

class App extends Component {
  render () {
    return (
      <Router history={browserHistory}>
        <Route
          path={'/'}
          component={connectToStores(Public)}
          onEnter={requireAuth}>
          <IndexRedirect to='/search/' />
          <Route path={'/profile'} component={ProfileSettings}>
            <IndexRedirect to='/profile/profile_info' />
            <Route path='profile_info' component={PersonalInfo} />
            <Route path='preferences' component={Preferences} />
            <Route path='security' component={Security} />
          </Route>
          <Route path={'/search'} component={Search}>
            <IndexRedirect to='/search/region' />
            <Route path={'properties'} component={PropertiesList} />
            <Route path={'map'} component={MapSearch} />
            <Route path={'region'} component={SearchByContinent} />
            <Route path={'region/:continent'} component={SearchByCountry} />
            <Route
              path={'region/:continent/:country'}
              component={SearchByCity}
            />
            <Route
              path={'region/:continent/:country/:city'}
              component={SearchCityDetails}
            />
          </Route>
          <Route path={'/property/:id'} component={PropertyDetails} />
          <Route path={'/favorite'} component={Favorite}>
            <IndexRedirect to='/favorite/properties' />
            <Route path='properties' component={FavoriteProperties} />
            <Route path='list' component={FavoriteList} />
            <Route path='map' component={FavoriteMap} />
          </Route>
        </Route>
        <Route path={'/landing'} component={connectToStores(Landing)}>
          <Route path={'signup'} component={Signup}>
            <IndexRedirect to='/landing/signup/profile' />
            <Route path={'profile'} component={Profile} />
            <Route path={'settings'} component={Settings} />
            <Route path={'more-settings'} component={MoreSettings} />
            <Route path={'password'} component={Password} />
            <Route path={'terms'} component={Terms} />
            <Route path={'ncnda'} component={OnboardingNCNDA} />
            <Route path={'success'} component={Success} />
            <Route path={'error'} component={SignupError} />
          </Route>
          <Route path={'login'} component={connectToStores(Login)} />
          <Route path={'about_pangaea'} component={AboutPangaea} />
          <Route path={'reset'} component={ResetPassword} />
        </Route>
        <Route path={'/agreements'} component={Agreements}>
          <IndexRedirect to='/agreements/letter_of_intent' />
          <Route path={'sales_mandate'} component={SalesMandate} />
          <Route path={'letter_of_intent'} component={LetterOfIntent} />
          <Route
            path={'collaboration_agreement'}
            component={CollaborationAgreement}
          />
          <Route
            path={'ambassador_agreement'}
            component={AmbassadorAgreement}
          />
          <Route path={'non_disclosure_and_fee_agreement'} component={NDFA} />
          <Route
            path={'commission_agreement'}
            component={CommissionAgreement}
          />
          <Route path={'non_disclosure_agreement'} component={NDA} />
        </Route>
        <Route path={'/activate_account/:id'} component={ActivateAccount} />
        <Route path={'/admin-login'} component={connectToStores(LoginAdmin)} />
        <Route
          path={'/admin'}
          component={connectToStores(AdminPublic)}
          onEnter={requireAdminAuth}>
          <IndexRedirect to='/admin/properties' />
          <Route path={'properties'} component={AdminProperties} />
          <Route path={'properties/:id'} component={AdminPropertyDetails} />
          <Route path={'users'} component={AdminUsers} />
          <Route path={'users/:id'} component={AdminUserDetails} />
          <Route path={'requests'} component={AdminRequests} />
          <Route path={'categories'} component={AdminCategories} />
          <Route path={'categories/:id'} component={EditCategory} />
          <Route path={'locations'} component={AdminLocations}>
            <IndexRedirect to='cities' />
            <Route path={'continents'} component={AdminContinents} />
            <Route path={'continents/:id'} component={EditContinent} />
            <Route path={'countries'} component={AdminCountries} />
            <Route path={'countries/:id'} component={EditCountry} />
            <Route path={'cities'} component={AdminCities} />
            <Route path={'cities/:id'} component={EditCity} />
          </Route>
          <Route path={'admins'} component={AdminsOverview} />
          <Route path={'admins/:id'} component={EditAdmin} />
        </Route>
        <Route path='*' component={Error} />
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js